module.exports = __webpack_public_path__ + "img/item-5.133d06ed.png";